import { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import type { FeatureCollection } from "geojson";
import type { LngLatLike } from "../lib/units";

const URL_ROOT = "https://photon.komoot.io/api/?q=";

interface Props {
    onSelect: (ll: LngLatLike, ur: LngLatLike, title: string) => void;
}

interface PhotonProperties {
    extent?: [number, number, number, number];
    name?: string;
    type?: string;
    state?: string;
}

export function MapSearchBar({ onSelect }: Props) {
    const [query, setQuery] = useState("");
    const [result, setResult] = useState<FeatureCollection<any, PhotonProperties> | null>(null);
    const [focused, setFocused] = useState(false);
    const width = focused ? 50 : 21.1;

    let nextQueryId = 0;
    let lastSeenId = 0;

    async function search(q: string) {
        const myId = ++nextQueryId;
        try {
            const resp = await fetch(URL_ROOT + encodeURIComponent(q));
            const data = (await resp.json()) as FeatureCollection<any, PhotonProperties>;
            if (myId > lastSeenId) {
                lastSeenId = myId;
                setResult(data);
            }
        } catch (err) {
            console.error("Photon search failed:", err);
        }
    }

    return (
        <div>
            <InputGroup
                size="lg"
                style={{ width: `${width}em`, transition: "all 1.5s" }}
            >
                <InputGroup.Text>Search for</InputGroup.Text>
                <Form.Control
                    type="text"
                    value={query}
                    placeholder="anywhere (type to search)"
                    onChange={(e) => setQuery(e.currentTarget.value)}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            search(query);
                        }
                    }}
                    style={{
                        backgroundColor: "rgba(68, 68, 68, 0.65)",
                        borderColor: "#FFBF00",
                        color: "white",
                    }}
                />
                {result === null ? (
                    <Button onClick={() => search(query)}>
                        <i className="bi bi-search" />
                    </Button>
                ) : (
                    <Button variant="danger" onClick={() => setResult(null)}>
                        <i className="bi bi-trash" />
                    </Button>
                )}
            </InputGroup>
            <br />
            {result !== null &&
                result.features.map((f, idx) => {
                    const ext = f.properties?.extent;
                    if (!ext) return null;
                    const [w, n, e, s] = ext;
                    const label = `${f.properties?.type ?? ""}/${f.properties?.name ?? ""}/${f.properties?.state ?? ""}`;
                    return (
                        <Button
                            key={idx}
                            variant="outline-warning"
                            onClick={() => {
                                onSelect({ lng: w, lat: s }, { lng: e, lat: n }, label);
                                setResult(null);
                                setQuery("");
                            }}
                            style={{ margin: "3px" }}
                        >
                            {label}
                        </Button>
                    );
                })}
        </div>
    );
}
